<template>
    <div class="editCube">
      <editBox :btnHide="true">
        <div class="infoCol infoColEdit">
          <div>參觀日期</div>
          <DateInput :defaultValue="item.date" @input="item.date=$event "/>
        </div>
        <div class="infoCol infoColEdit">
          <div>參觀時段</div>
          <TimeInput :defaultValue="item.visitTime" @input="item.visitTime=$event " :interval="5"></TimeInput>
        </div>
        <div class="infoCol infoColEdit">
          <div>預約人</div>
          <div><input type="text" v-model="item.orderer" :style="{width: '145px'}"></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>預約電話</div>
          <div><input type="text" v-model="item.ordererTel" :style="{width: '205px'}"></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>代理商</div>
          <div class="agencyID"><div>{{item.agencyName}} <button v-if="item.agencyID||item.agencyName" @click="item.agencyID=null;item.agencyName=null"><svg width="10" height="10" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.6797 1.32004C19.1097 0.750008 18.1859 0.750008 17.6159 1.32004L10.2072 8.72876L2.79815 1.32004C2.22812 0.750008 1.30433 0.750008 0.73429 1.32004C0.164254 1.89008 0.164254 2.81387 0.73429 3.38391L8.1433 10.7929L0.73429 18.2016C0.164254 18.7717 0.164254 19.6955 0.73429 20.2655C1.01916 20.5504 1.39276 20.6928 1.76637 20.6928C2.13997 20.6928 2.51328 20.5504 2.79844 20.2655L10.2075 12.8565L17.6165 20.2655C17.9013 20.5504 18.2749 20.6928 18.6485 20.6928C19.0221 20.6928 19.3954 20.5504 19.6806 20.2655C20.2506 19.6955 20.2506 18.7717 19.6806 18.2016L12.271 10.7926L19.68 3.38362C20.2498 2.81387 20.2498 1.88979 19.6797 1.32004Z" fill="white"/>
            </svg>
            </button></div><button @click="setClass"></button></div>
          <!-- <div><S1 v-model="item.agencyID">
            <option v-for="(agency, i) in agencies" :key="`agency-${i}`" :value="agency.taxID">
              {{agency.taxID}} | {{agency.name}}</option></S1></div> -->
        </div>
        <div class="infoCol infoColEdit">
          <div>領隊電話</div>
          <div><input type="text" v-model="item.leaderTel" @change="findLeaderName" :style="{width: '205px'}"></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>領隊</div>
          <div><input type="text" v-model="item.leader"  :style="{width: '145px'}"></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>團體名稱</div>
          <div><input type="text" v-model="item.groupName"  :style="{width: '245px'}"></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>團體屬性</div>
          <div><S1 :defaultValue="item.teamAttributes" @input="item.teamAttributes=$event; "  :style="{width: '245px'}">
            <option v-for="teC in teamAttributes" :key="teC" :value="teC">{{teC}}</option>
            </S1></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>地區</div>
          <div>
            <S1 :defaultValue="item.area" @input="item.area=$event " :style="{width:'145px'}">
              <option :value="null">縣市</option>
              <option v-for="(country, i) in countries" :key="`country-${i}`" :value="country">{{country}}</option>
            </S1>
          </div>
        </div>
      </editBox>
      <editBoxH :btnHide="true" label="參觀資訊">
        <div class="infoCol2 infoColEdit">
          <div>參觀團數</div>
          <div><input type="text" v-model.number="item.groupNum" :style="{width: '70px', textAlign: 'center', paddingLeft: 0, }"></div>
        </div>
        <div class="infoCol2 infoColEdit">
          <div>預約人數</div>
          <div><input type="text" v-model.number="item.reserveNum" @change="calculatePrice" :style="{width: '70px', textAlign: 'center', paddingLeft: 0, }"></div>
        </div>
        <div class="infoCol2 infoColEdit">
          <div>票種</div>
        </div>
        <div class="ticketCategory">
          <div>一般<input type="text" v-model.number="ticketCategory.ticket_1" @change="calculatePriceTicket"></div>
          <div>優待<input type="text" v-model.number="ticketCategory.ticket_2" @change="calculatePriceTicket"></div>
          <div>優惠<input type="text" v-model.number="ticketCategory.ticket_3" @change="calculatePriceTicket"></div>
        </div>
        <hr class="hrgrey">
        <div class="infoCol2 infoColEdit">
          <div>導覽需求</div>
        </div>
        <div class="guide">
          <input type="radio" :value="null" label="待確認" v-model="item.guideNeeds">
          <input type="radio" :value="false" label="不需要" v-model="item.guideNeeds">
          <label for="">
            <input type="radio" :value="true" label="需要" v-model="item.guideNeeds" @change="calculatePrice" @click="item.docentCount=item.docentCount?item.docentCount:item.groupNum">
            <div>
              <div>聘 <input type="text" v-model.number="item.docentCount" @change="calculatePrice"> 名</div>
              <div><div :style="{width: '70px', textAlign: 'start'}">導覽主題</div>
              <S1 :defaultValue="item.guideRemark" @input="item.guideRemark=$event " :width="'150px'">
                <option v-for="(gt, i) in guideTopic" :key="`guideTopic-${i}`" :value="gt">{{gt}}</option>
              </S1></div>
            </div>
          </label>
        </div>
        <hr class="hrdeco">
        <div class="guideTotal">
          <span>總人數  <span :style="{color: '#E37878'}">{{item.reserveNum}}</span>  人</span>
          <span>總金額  <span :style="{color: '#E37878'}">{{price}}</span>  元</span>
        </div>
        <div class="guideTotal" :style="{marginTop: '10px'}">
          <span></span>
          <span>匯款預付  <span :style="{color: '#E37878', fontSize: '20px'}">{{prePayCalculateEdit}}</span>  元</span>
        </div>
      </editBoxH>
      <editBoxH :btnHide="true" label="備註">
        <textarea class="remark" v-model="item.remark"></textarea>
      </editBoxH>
      <editBoxH :btnHide="true" label="業務經辦(員工)">
        <div class="salesman infoCol infoColEdit">
          <div :style="{width: '2.5em', minWidth: '2.5em'}">來源</div>
        <S1 :defaultValue="item.source" @input="item.source=$event " class="salesman" :style="{width: '180px', marginBlock: 'auto'}">
          <option value=""></option>
          <option v-for="(sman, i) in sources" :key="`sources-${i}`" :value="sman.key">
            {{sman.key}}</option>
        </S1>
        </div>
        <div class="salesman infoCol infoColEdit">
          <div :style="{width: '2.5em', minWidth: '2.5em'}">經辦</div>
        <S1 :defaultValue="item.salesman" @input="item.salesman=$event " class="salesman" :style="{width: '300px', marginBlock: 'auto'}">
          <option value=""></option>
          <option v-for="(sman, i) in salesmans" :key="`sman-${i}`" :value="sman._id">
            {{sman.department}} | {{sman.post}} | {{sman.name}}</option>
        </S1>
        </div>
      </editBoxH>
      <div class="btns">
        <button class="cancel" @click="$emit('close')">取消</button>
        <button class="confirm" @click="save" :disabled="!vaild">儲存</button>
      </div>
      <agSelector ref="agencybox" :show="getAgency" :items="agencyText?[{taxID: agencyText, name: agencyText}, ...agenciesShort] : agenciesShort" @search="agencyText=$event" :search="agencyText">
        <div slot-scope="{item:itm}" @click="item.agency=JSON.parse(JSON.stringify(itm));item.agencyName=itm.name;item.agencyID=itm.taxID;getAgency=false">
          <div>{{itm.name}}</div>
        </div>
      </agSelector>
      <agSelector :show="getMember" :items="members" @search="memberText=$event" :search="memberText">
        <div slot-scope="{item:itm}" @click="item.member=JSON.parse(JSON.stringify(itm));getMember=false" :style="{gap: '20px'}">
          <div>{{itm.mobile || '------------'}}</div> <div>{{itm.name}}</div>
        </div>
      </agSelector>
    </div>
</template>

<script>
import S1 from '../../components/select.vue'
import agSelector from '../restaurantView/agencySelector.vue'
import editBox from '../../components/editBox'
// import RBtn from '../../components/btn/round.vue'
import DateInput from '../../components/input/date.vue'
import TimeInput from '../../components/input/time.vue'
import editBoxH from '../../components/editBoxWithHeader'
import { getapi, putapi } from '../../store/fetch'
export default {
  components: {
    S1,
    editBox,
    editBoxH,
    DateInput,
    TimeInput,
    agSelector
  },
  watch: {
    agencyText () {
      this.getagenciesShort()
    },
    getAgency () {
      if (this.getAgency) {
        this.getMember = false
        this.getagenciesShort()
      }
    },
    getMember () {
      if (this.getMember) {
        this.getAgency = false
        this.getMembers()
      }
    },
    memberText () {
      this.getMembers()
    },
    'item.leader' () {
      if (this.item.leader.length === 10) {
        this.getLeader()
      } else {
        this.leader = null
      }
    },
    'item.reserveNum' () {
      this.calculatePrice()
    },
    'item.docentCount' () {
      this.calculatePrice()
    },
    'item.guideNeeds' () {
      this.calculatePrice()
    }
  },
  data () {
    return {
      searchAgency: null,
      selectAgency: false,
      price: 0,
      agencies: [],
      members: [],
      feeSplitting: {
        ticket: {
          agency: 80,
          leader: 20
        },
        consume: {
          agency: 20,
          leader: 80
        }
      },
      countries: [],
      ticketCategory: {
        ticket_1: 0,
        ticket_2: 0,
        ticket_3: 0,
        ticket_4: 0
      },
      Prepaid: 0,
      PrepaidDocent: 0,
      disabledDates: [],
      item: {
        date: this.moment().add(1, 'day').format('YYYY-MM-DD'),
        visitTime: '08:00',
        orderer: null,
        ordererTel: null,
        agencyID: null,
        agencyName: null,
        comTaxID: null,
        leader: null,
        leaderTel: null,
        groupName: null,
        remark: null,
        salesman: null,
        source: '自來電',
        guide: null,
        guideRemark: '綜合導覽',
        guideNeeds: null,
        docentCount: null,
        teamAttributes: null,
        groupNum: 1,
        area: null
      },
      fieldsDetial: [
        '參觀日期',
        '參觀時段',
        '預約人',
        '代理商',
        '統一編號',
        '領隊電話',
        '領隊',
        '團體名稱'
      ],
      fieldsDetial2: [
        '預約人數',
        '導覽需求',
        '票種',
        '總金額',
        '匯款預付'
      ],
      salesmans: [],
      tickets: [],
      guideTopic: [],
      agenciesShort: [],
      memberText: null,
      agencyText: null,
      getMember: false,
      getAgency: false
    }
  },
  computed: {
    vaild () {
      return true
    },
    prePayCalculateEdit () {
      let c = 0
      // console.log(this.item.guideNeeds, this.item.docentCount, this.PrepaidDocent, this.Prepaid)
      if (this.item.guideNeeds && this.item.docentCount) {
        c = c + this.PrepaidDocent * this.item.docentCount
      }
      c = c + this.Prepaid
      return c
    }
  },
  methods: {
    async findLeaderName () {
      if (this.item.leader) {} else {
        if (this.item.leaderTel.length > 8) {
          const u = await getapi(`users/leader/tel?tel=${this.item.leaderTel}`)
          if (u && u.length > 0) {
            this.item.leader = u[0].name
          }
        }
      }
    },
    setClass () {
      this.getAgency = !this.getAgency
      setTimeout(() => {
        this.$nextTick(() => {
          console.log(this.selectAgency, this.$refs.agencybox, this.$refs.agencybox?.$el, 'this.$refs.agencybox')
          if (this.selectAgency) {
            this.$refs.agencybox.classList.remove('slide-out')
            this.$refs.agencybox.classList.add('slide-in')
          } else {
            this.$refs.agencybox.classList.remove('slide-in')
            this.$refs.agencybox.classList.add('slide-out')
          }
        })
      }, 100)
    },
    calculatePriceTicket () {
      const tk1 = this.ticketCategory && this.ticketCategory.ticket_1 ? this.ticketCategory.ticket_1 : 0
      const tk2 = this.ticketCategory && this.ticketCategory.ticket_2 ? this.ticketCategory.ticket_2 : 0
      const tk3 = this.ticketCategory && this.ticketCategory.ticket_3 ? this.ticketCategory.ticket_3 : 0
      this.item.reserveNum = tk1 + tk2 + tk3
      const price = this.tickets.map(e => {
        // console.log(e.price * (this.ticketCategory[e.ref_name] ? this.ticketCategory[e.ref_name] : 0), e.ref_name, e.price, this.ticketCategory[e.ref_name])
        return e.price * (this.ticketCategory[e.ref_name] ? this.ticketCategory[e.ref_name] : 0)
      }).reduce((a, b) => a + b, 0)
      const priceGuide = !this.item.guideNeeds ? 0 : (this.item.docentCount ? this.item.docentCount * this.PrepaidDocent : this.PrepaidDocent)
      // console.log(price, priceGuide)
      this.price = price + priceGuide
    },
    calculatePrice () {
      const number = this.item.reserveNum ? this.item.reserveNum : 0
      const tk2 = this.ticketCategory.ticket_2 ? this.ticketCategory.ticket_2 : 0
      const tk3 = this.ticketCategory.ticket_3 ? this.ticketCategory.ticket_3 : 0
      this.ticketCategory.ticket_1 = number - tk2 - tk3
      const price = this.tickets.map(e => {
        // console.log(e.price * (this.ticketCategory[e.ref_name] ? this.ticketCategory[e.ref_name] : 0), e.ref_name, e.price, this.ticketCategory[e.ref_name])
        return e.price * (this.ticketCategory[e.ref_name] ? this.ticketCategory[e.ref_name] : 0)
      }).reduce((a, b) => a + b, 0)
      const priceGuide = !this.item.guideNeeds ? 0 : (this.item.docentCount ? this.item.docentCount * this.PrepaidDocent : this.PrepaidDocent)
      // console.log(price, priceGuide)
      this.price = price + priceGuide
    },
    async save () {
      // console.log({ ...this.item, ticketCategory: this.ticketCategory })
      const data = { ...this.item, ticketCategory: this.ticketCategory }
      data.visitDate = this.moment(data.date).toDate()
      data.totalAmount = this.price
      const team = {
        leaderName: this.item.leader,
        leaderMobile: this.item.leaderTel,
        teamName: this.item.groupName,
        teamNum: this.item.reserveNum,
        feeSplitting: {
          ticket: { agency: 100, leader: 0 },
          consume: { agency: 100, leader: 0 }
        }
      }
      data.teamTemp = [...Array(this.item.groupNum).keys()].map(e => team)
      const r = await putapi('visitbooking/v2/local', data)
      if (r) {
        this.$emit('new', r)
      }
    },
    async getSalesman () {
      const salesmans = await getapi('users/local/short')
      this.salesmans = salesmans
    },
    async getMembers () {
      if (this.memberText || this.getMember) {
        const params = {}
        if (this.memberText) {
          params.Search = this.memberText
        }
        this.members = await getapi('users/recent?' + new URLSearchParams(params))
      } else {
        this.members = []
      }
    },
    async getagenciesShort () {
      if (this.agencyText || this.getAgency) {
        const params = {}
        if (this.agencyText) {
          params.search = this.agencyText
        }
        this.agenciesShort = await getapi(`agencies/short?${new URLSearchParams(params)}`)
      } else {
        this.agenciesShort = []
      }
    },
    async getTicket () {
      const tickets = await getapi('products/tickets/refs')
      this.tickets = tickets
      const PrepaidDocent = await getapi('selections/PrepaidDocent')
      this.PrepaidDocent = PrepaidDocent ? parseInt(PrepaidDocent) : 0
      const Prepaid = await getapi('selections/Prepaid')
      this.Prepaid = Prepaid ? parseInt(Prepaid) : 0
    },
    async getLeader () {
      if (this.item.leader) {
        const leader = await getapi(`users/leader/tel?tel=${this.item.leader}`)
        if (leader.length === 1) {
          this.leader = leader[0].name
        } else if (leader.length === 0) {
          this.leader = null
        }
      }
    }
  },
  props: ['show', 'addTeam', 'teamAttributes', 'sources'],
  async mounted () {
    this.countries = await getapi('selections/country')
    this.getagenciesShort()
    this.getSalesman()
    this.getTicket()
    this.disabledDates = await getapi('selections/bookTime')
    this.guideTopic = await getapi('selections/guideTopic')
  },
  created () {
    if (typeof this.addTeam === 'object') {
      this.item.date = this.moment(this.addTeam.visitDate).format('yyyy-MM-DD')
      this.item.orderer = this.addTeam.orderer
      this.item.ordererTel = this.addTeam.ordererTel
      this.item.agencyID = this.addTeam.agencyID
      this.item.agencyName = this.addTeam?.agencyName
      this.item.reserveNum = this.addTeam.reserveNum + this.addTeam.reserveNumChild
      this.ticketCategory.ticket_1 = this.addTeam.reserveNum
      this.ticketCategory.ticket_2 = this.addTeam.reserveNumChild
      this.item.source = this.addTeam.source
      this.item.salesman = this.addTeam.salesman._id
    }
  }
}
</script>
<style lang="scss" scoped>
.NewTeam {
  position: fixed;
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }
}
.selectAgency {
  position: fixed;
  left: -374px;
  bottom: 47px;
  z-index: -1;
  display: flex!important;
  flex-direction: column;
  width: 370px;
  transform: translateX(calc(100% + 15px));
  min-height: 550px;
  max-height: 550px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px 0px 0px 10px;
  background-color: #FFFFFF;
  &>div:nth-child(1) {
    width: 100%;
    padding-inline: 36px;
    padding-top: 24px;
    padding-bottom: 10px;
    height: fit-content;
  }
  &>div:nth-child(2) {
    overflow-y: scroll;
    margin-inline: 16px;
    padding-inline: 19px;
    margin-bottom: 10px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
      width: 7px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      box-shadow: inset 0 0 6px #0000004d;
      background-color: var(--color-checked);
    }
    &::-webkit-scrollbar-track {
      border-inline: 2px solid transparent!important;
      // border: 3px solid transparent;
      background-color: #d8d8d8;
      border-radius: 20px;
      width: 7px;
      box-sizing: border-box;
      border: 2px solid #FFFFFF!important;
    }
    &>div {
      width: 100%;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      height: 50px;
      min-height: 50px;
      text-align: start;
      display: flex;
      align-items: center;
      &.checked {
        background-color: #E9F5FC;
      }
      &:hover {
        background-color: #E9F5FC;
      }
    }
  }
}
.agencyID {
  display: flex;
  &>div {
    box-sizing: border-box;
    width: 200px;
    height: 40px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-inline: 12px;
    text-align: start;
    white-space: nowrap;
    flex-wrap: nowrap;
    overflow-x: hidden;
    position: relative;
    button {
      width: 20px;
      height: 20px;
      background-color: #B8B8B8;
      position: absolute;
      right: 3px;
      border: none;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      &:hover {
        background-color: #C4C4C4;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
      }
    }
  }
  &>button {
    width: 40px;
    height: 40px;
    background-color: var(--color-checked);
    mask-image: url(/selectbox.svg);
    mask-size: cibntain;
    mask-position: center;
    mask-repeat: no-repeat;
    border: none;
  }
}
.feeSplitting {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  height: 42px;
  height: 45px;
  &>div:nth-child(1) {
    width: 75px;
    min-width: 75px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &::before {
    width: 64px!important;
  }
  &>div {
    gap: 20px;
  }
  &>div>div {
    display: flex;
    align-items: center;
    gap: 3px;
  }
  input {
    height: 30px;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    text-align: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    text-align: center;
    color: var(--color-letter);
  }
}
div.salesman {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
select.salesman {
  width: 300px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 3px;
  justify-self: flex-start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  padding-inline: 12px;
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;

  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.guideTotal {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  padding-inline: 20px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: var(--color-letter);
}
.guide {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 18px;
  label {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: var(--color-letter);
    gap: 32px;
    &>div {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &>div > div {
      display: flex;
      align-items: center;
      gap: 5px;
      &>input {
        width: 50px;
        height: 30px;
        border: 1px solid #C4C4C4;
        box-sizing: border-box;
        border-radius: 3px;
        text-align: center;
      }
      select {
        padding-block: 0px;
        width: 140px;
        height: 30px;
        border: 1px solid #C4C4C4;
        box-sizing: border-box;
        border-radius: 3px;
        text-align: start;
        font-family: Noto Sans TC;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        padding-inline: 9px;
      }
    }
  }
  input[type=radio] {
    appearance: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    &::before {
      display: inline-block;
      box-sizing: border-box;
      content: '';
      width: 24px;
      height: 24px;
      border-radius: 12px;
      border: 2px solid var(--color-pri);
    }
    &:checked::before {
      background-image: url(/checked.svg);
      background-color: var(--color-checked);
      background-position: center;
    }
    &::after {
      content: attr(label);
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: var(--color-letter);
    }
  }
}
.hrgrey {
  margin-top: 19px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid var(--color-border);
}
.ticketCategory {
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: flex-start;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  &>div{
    display: flex;
    align-items: center;
    gap: 12px
  }
  input {
    width: 50px;
    height: 25px;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    text-align: center;
  }
}
textarea.remark {
  width: 100%;
  height: fit-content;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  text-align: start;
  color: var(--color-letter);
  min-height: 200px;
  border: 1px solid #C4C4C4;
}
.hrdeco {
  height: 12px;
  background-color: var(--color-pri);
  border-inline: 10px solid var(--color-pri);
  border-block: 5.5px solid #FFFFFF;
  width: 100%;
  margin-block: 10px;
  // background-color: transparent;
  // width: 100%;
  // mask-image: url(/hrdeco.svg);

  // mask-size: contain;
  // mask-repeat: no-repeat;
  // mask-position: center;
  // border: none;
}
.infofoot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #999999;
}
.footCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: end;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  height: 32px;
}
.infoCol2 {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  height: 40px;
  &>div:nth-child(1) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
.infoCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  height: 40px;
  &>div:nth-child(1) {
    width: 90px;
    min-width: 90px;
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>

<style lang="scss">
.NewTeam {
  .datetimepicker {
    right: 0;
  }
  .date-time-picker.getTime {
    height: 40px;
    width: 200px;
    .field {
      height: 40px;
      width: 200px;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 36px;
        height: 40px;
        mask-size: contain;
        background-color: var(--color-checked);
        mask-size: 22px;
        mask-image: url(/clock.svg);
        // background-image: url(/calendar.svg);
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }
    .field-input {
      height: 40px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 18px!important;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      // background: url(/calendar.svg) center/90% no-repeat;
      opacity: 1;
      background-position: calc(100% - 10px);
      background-size: 20px;
      padding-top: 6px;
      padding-right: 40px;
      &::placeholder {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        letter-spacing: 0.1em;
      }
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
  .date-time-picker.getDate {
    height: 40px;
    width: 200px;
    .field {
      height: 40px;
      width: 200px;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 36px;
        height: 40px;
        mask-size: contain;
        background-color: var(--color-checked);
        mask-size: 22px;
        mask-image: url(/calendar2.svg);
        // background-image: url(/calendar.svg);
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }
    .field-input {
      height: 40px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 18px!important;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      // background: url(/calendar.svg) center/90% no-repeat;
      opacity: 1;
      background-position: calc(100% - 10px);
      background-size: 20px;
      padding-top: 6px;
      padding-right: 40px;
      &::placeholder {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        letter-spacing: 0.1em;
      }
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
}
</style>
<style lang="scss" scoped>

.editCube {
  flex: 1;
  padding: 31px 20px 30px 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  align-content: flex-start;
  gap: 19px;
}
.infoColEdit {
  height: 60px;
  box-sizing: border-box;
  &>:nth-child(2)>input[type=text], &>:nth-child(2)>select {
    height: 40px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-left: 14px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    box-sizing: border-box;
  }
  input[type=radio] {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    appearance: none;
    background-color: #B8B8B8;
    color: #FFFFFF;
    &::after {
      content: attr(value);
    }
    border: none;
    border-radius: 3px;
    font-size: 16px;
    &:checked {
      background-color: var(--color-checked);
    }
  }
  // &>:nth-child(2)>input[type=date]::-webkit-calendar-picker-indicator {
  //   background: url(/calendar.svg) center/90% no-repeat;
  //   color: rgba(0, 0, 0, 0);
  //   opacity: 1;
  //   background-position: calc(100% - 10px);
  //   background-size: 20px;
  //   width: 25px;
  // }
  // &>:nth-child(2)>input[type=time]::-webkit-calendar-picker-indicator {
  //   background: url(/clock.svg) center/90% no-repeat;
  //   color: rgba(0, 0, 0, 0);
  //   opacity: 1;
  //   background-size: 16px 13px;
  //   background-position: calc(100% - 10px);
  //   width: 20px;
  // }
  &>:nth-child(2)>input[type=text] {
    color: var(--color-letter);
  }
  &>:nth-child(2)>select {
    color: var(--color-checked);
  }
  &:nth-child(1)>:nth-child(2)>input, &:nth-child(1)>:nth-child(2)>select { width: 201px; }
  &:nth-child(2)>:nth-child(2)>input, &:nth-child(2)>:nth-child(2)>select { width: 175px; }
  &:nth-child(3)>:nth-child(2)>input, &:nth-child(3)>:nth-child(2)>select { width: 145px; }
  &:nth-child(4)>:nth-child(2)>input, &:nth-child(4)>:nth-child(2)>select { width: 247px; }
  &:nth-child(5)>:nth-child(2)>input, &:nth-child(5)>:nth-child(2)>select { width: 200px; }
  &:nth-child(6)>:nth-child(2)>input, &:nth-child(6)>:nth-child(2)>select { width: 247px; }
  &:nth-child(7)>:nth-child(2)>input, &:nth-child(7)>:nth-child(2)>select { width: 147px; }
  &:nth-child(8)>:nth-child(2)>input, &:nth-child(8)>:nth-child(2)>select { width: 247px; }
}
</style>
